import Vue from 'vue';


// apiPath: 'http://localhost:8888/activation.php',
// sitePath: 'http://localhost:8080/aktivoi',


const configuration   = {
    data: {
        xgo2_enabled: true,
        apiPath: 'https://xploramobile.com/backend/aktivoi/api.php',
        sitePath: 'https://xplora.fi/aktivoi',
        bp: {
            enabled: false,
            url: "https://bp.xplora.fi",
            market: "xplorafi",
            campaign: "xplorafi_raf1",
        }
    }
};
export const EventBus = new Vue(configuration);



// WEBPACK FOOTER //
// ./src/components/EventBus.js